// 3rd Party
import React, { FC } from 'react';

// Utils
import { PERMISSIONS } from '@/utils/permissions';

// Components
import MarketingBanner from '@/views/components/misc/MarketingBanner';

// Assets
import FilesPreview from '@/images/design-system-v2/upload/filesPreview.svg';

const AIStatementReaderBanner: FC = () => {
  // Cookie is set for 90 days
  const BANNER_COOKIE_LENGTH = 7776000;
  const DISMISSED_BANNER_COOKIE_KEY = 'ai-statement-reader-banner-dismissed';
  const i18nBasePath = 'Modal.PortfolioUpload.AIStatementReaderBanner';
  const link = 'https://capintel.com/ai-statement-reader';

  return (
    <MarketingBanner
      bannerCookieKey={DISMISSED_BANNER_COOKIE_KEY}
      bannerCookieLength={BANNER_COOKIE_LENGTH}
      bannerImage={FilesPreview}
      i18nBasePath={i18nBasePath}
      permissionKey={PERMISSIONS.PORTFOLIOS_AI_STATEMENT_READER_BANNER}
      link={link}
      className="ai-statement-reader-banner"
    />
  );
};

export default AIStatementReaderBanner;
